import type { TFunction } from 'i18next';

export function statusLabel(status: string, t: TFunction): string {
  switch (status) {
    // SC-542: an order awaiting its online payment is not confirmed. Without an
    // explicit case it falls through to 'received' below and tells the customer
    // « Reçue » while they have not paid — the same false confirmation the
    // restaurant used to get.
    case 'pending_payment': return t('orderStatus.pending_payment');
    case 'preparing': return t('orderStatus.preparing');
    case 'ready': return t('orderStatus.ready');
    case 'handed_over': return t('orderStatus.handed_over');
    case 'cancelled': return t('orderStatus.cancelled');
    default: return t('orderStatus.received');
  }
}

export function paymentLabel(status: string, t: TFunction): string {
  if (status === 'PAID') return t('payment.paid');
  if (status === 'PARTIAL') return t('payment.partial');
  return t('payment.pending');
}
